import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isLoadingAll: 'commons/isLoadingAll',
      isLoadingMore: 'commons/isLoadingMore',
      isLoadingPost: 'commons/isLoadingPost',
      isTargetNone: 'commons/isTargetNone'
    }),
    isLoading () {
      if (this.isLoadingAll) {
        document.body.classList.add('loading-sort')
      } else if (!this.isLoadingAll) {
        document.body.classList.remove('loading-sort')
      }
      if (this.isLoadingMore) {
        document.body.classList.add('loading-more')
      } else if (!this.isLoadingMore) {
        document.body.classList.remove('loading-more')
      }
      if (this.isLoadingPost) {
        document.body.classList.add('loading-post')
      } else if (!this.isLoadingPost) {
        document.body.classList.remove('loading-post')
      }
      return this.isLoadingAll || this.isLoadingMore || this.isLoadingPost
    },
    isRenderNoneMessage () {
      return this.isTargetNone
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loadings.js